import React from "react";
import { Star } from "lucide-react";

export function StarRating({
  value = 0,
  max = 5,
  onChange,
  size = 20,
  readonly = false,
  className = "",
}) {
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} role={readonly ? undefined : "radiogroup"} aria-label="Rating">
      {Array.from({ length: max }).map((_, i) => {
        const pos = i + 1;
        const filled = pos <= Math.round(value);
        const half = !filled && pos - value < 1 && pos - value > 0;
        return (
          <button
            key={pos}
            type="button"
            data-testid={`star-rating-${pos}`}
            disabled={readonly}
            onClick={() => !readonly && onChange && onChange(pos)}
            aria-label={`${pos} out of ${max}`}
            className={`${readonly ? "cursor-default" : "cursor-pointer hover:scale-110 transition-transform"} ${filled || half ? "text-amber-400" : "text-neutral-300"} bg-transparent p-0 leading-none`}
          >
            <Star size={size} strokeWidth={1.75} className={filled ? "fill-current" : half ? "fill-current opacity-60" : ""} />
          </button>
        );
      })}
    </div>
  );
}

export default StarRating;
